var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7723 16.7723C16.4687 17.0759 15.9708 17.0759 15.6611 16.7723L9 10.1112L2.3389 16.7723C2.03529 17.0759 1.53738 17.0759 1.2277 16.7723C0.924099 16.4687 0.924099 15.9708 1.2277 15.6611L7.8888 9L1.2277 2.3389C0.924099 2.03529 0.924099 1.53738 1.2277 1.2277C1.53131 0.924099 2.02922 0.924099 2.3389 1.2277L9 7.8888L15.6611 1.2277C15.9647 0.924099 16.4626 0.924099 16.7723 1.2277C17.0759 1.53131 17.0759 2.02922 16.7723 2.3389L10.1112 9L16.7723 15.6611C17.0759 15.9708 17.0759 16.4687 16.7723 16.7723Z",
    fill: "#10132C",
    stroke: "#10132C",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f5ff0ac67c3da2eb0ed7a7bc5936c9e2.svg";
export { ForwardRef as ReactComponent };